'use strict';
const schema_1 = require("../schema");
var schema = new schema_1.Schema({
    include: [
        require('./default_safe')
    ],
    explicit: [
        require('../type/js/undefined'),
        require('../type/js/regexp')
    ]
});
schema_1.Schema.DEFAULT = schema;
module.exports = schema;
//# sourceMappingURL=default_full.js.map